import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PageSection from '../../components/PageSection';

const styles = theme => ({
  root: {
    padding: 20,
    marginBottom: 30
  },
  font: {
    fontSize: 19,
    color: theme.palette.grey.main,
    textAlign: 'justify'
  },
  introTitle: {
    color: theme.palette.primary.main,
    fontSize: 48,
    fontWeight: 'bold',
    marginBottom: 30
  },
});

const guild = {
  id: 1,
  title: 'Piano Guild',
  description: `The American College of Musicians evaluates the students’ performances based upon their presentation
        of baroque, classic, romantic and modern works.
        Throughout the US and abroad, over 100,000 piano students participate yearly in the national piano auditions.
        The auditions serve as a great summative evaluation for parents, teacher, and student; and the report cards offer
        concrete feedback and record of progress.  Students are encouraged to become members of the National Piano Guild
        Association by participating in the National Piano Guild exams by completing a program of anywhere between 2-16
        memorized pieces. Participants receive a report card, certificate, and achievement pin.
        Audition centers are held in both Broward and Miami-Dade counties.`,
  image: 'https://musicology-studio.s3.amazonaws.com/Students_at_guild+certificates.jpg',
};

class Examinations extends Component {

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <PageSection section={guild} plain fullWidth circular />
      </div>
    )
  }
}

Examinations.propTypes = {
}

export default withStyles(styles)(Examinations);
